import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getGroupsServices } from "../../services/commonapi/commonApi";

export const fetchGroups = createAsyncThunk(
  "groups/fetchGroups",
  async (accessToken, { rejectWithValue }) => {
    try {
      const { status, data } = await getGroupsServices(accessToken);
      return status === 200
        ? data.data
        : rejectWithValue("Failed to fetch user data");
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const initialState = {
  groupsData: [],
  groupLoading: false,
  error: null,
};

const groupsSlice = createSlice({
  name: "groups",
  initialState,
  reducers: {
    resetGroupsState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGroups.pending, (state) => {
        state.groupLoading = true;
        state.error = null;
      })
      .addCase(fetchGroups.fulfilled, (state, { payload }) => {
        state.groupsData = payload;
        state.groupLoading = false;
      })
      .addCase(fetchGroups.rejected, (state, { payload }) => {
        state.groupLoading = false;
        state.error = payload;
      });
  },
});

export const { resetGroupsState } = groupsSlice.actions;
export default groupsSlice.reducer;
